import { CallEffect, PutEffect, SelectEffect } from 'redux-saga/effects'
import { OrganizationT, SystemConfiguration, type UserType } from '../types'

export type SessionT = {
  organizations: OrganizationT[]
  organization: OrganizationT
  user: UserType
  token: string
  fileDownloadSecret: string
  preventApplicationRender: boolean
  sessionState: boolean
}

export type LoginPayloadT = {
  user: UserType
  organization: OrganizationT
  organizations: OrganizationT[]
  token: string
  fileDownloadSecret: string
}

export type LoginActionT = {
  type: '@@SWA/LOGIN'
  payload: LoginPayloadT
}

export type LogoutPayloadT = {
  mustLoginWithSPM: boolean
  status?: number
}

export type LogoutActionT = {
  type: '@@SWA/LOGOUT'
  payload?: LogoutPayloadT
}

export type UnstablePreventApplicationFromRenderingActionT = {
  type: '@@SWA/UNSTABLE_PREVENT_APPLICATION_FROM_RENDERING'
}

export type SwitchOrganizationPayloadT = {
  currentPath: string
  oldOrganization: OrganizationT
  newOrganization: OrganizationT
}

export type SwitchOrganizationActionT = {
  type: '@@SWA/SWITCH_ORGANIZATION'
  payload: SwitchOrganizationPayloadT
}

type LoginSessionT = {
  user: UserType
  token: string
  fileDownloadSecret: string
  organizations: OrganizationT[]
}

export type LoginCredentialsType = {
  token?: string
  organizationKey?: string
}

export type ActiveSessionLoginResponseT = {
  loginSession: LoginSessionT
  configuration: SystemConfiguration
  redirectToPath?: string
  redirectTo?: string
}

export type LoginFailureActionT = {
  type: '@@SWA/LOGIN_FAILURE'
}

export type LoggedInSessionStateT = {
  user: UserType
  token: string
  fileDownloadSecret: string
  organizations: OrganizationT[]
  organization: OrganizationT
  preventApplicationRender: boolean
  sessionState: 'loggedIn'
}

type LoggedOutSessionStateT = {
  sessionState: 'loggedOut'
  mustLoginWithSPM?: boolean
}

export type UnknownSessionStateT = {
  sessionState: 'unknown'
}

type InactiveSessionLoginResponseT = {
  configuration: SystemConfiguration
  redirectTo?: string
}

export type SessionStateT =
  | LoggedInSessionStateT
  | LoggedOutSessionStateT
  | UnknownSessionStateT

export type SessionActionT =
  | LoginActionT
  | LogoutActionT
  | UnstablePreventApplicationFromRenderingActionT
  | LoginFailureActionT
  | SwitchOrganizationActionT

export type UniversalLoginResponseT =
  | InactiveSessionLoginResponseT
  | ActiveSessionLoginResponseT

interface Action {
  type: SessionActionT['type']
  payload?: { status?: number; error?: string }
}

type SagaEffect = PutEffect<Action> | CallEffect | SelectEffect

export type SessionSagaReturnType = Generator<SagaEffect, void, SessionStateT>

export function isLoggedInSessionState(
  session: SessionStateT
): session is LoggedInSessionStateT {
  return session.hasOwnProperty('organization')
}
